module.exports = __webpack_public_path__ + "static/media/loan.96fce80e.svg";